'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dStorage$0024$002dKeys$0024$0024anon$00241 from "./presto.-Storage$-Keys$$anon$1.js";
var $p;
function $s_Lpresto_Storage$Keys$__SignInWithEmail__Lpresto_Storage$Keys() {
  $m_Lpresto_Storage$Keys$();
  return $t_Lpresto_Storage$Keys$__SignInWithEmail;
}
export { $s_Lpresto_Storage$Keys$__SignInWithEmail__Lpresto_Storage$Keys as $s_Lpresto_Storage$Keys$__SignInWithEmail__Lpresto_Storage$Keys };
/** @constructor */
function $c_Lpresto_Storage$Keys$() {
  $n_Lpresto_Storage$Keys$ = this;
  $t_Lpresto_Storage$Keys$__SignInWithEmail = new $j_presto$002e$002dStorage$0024$002dKeys$0024$0024anon$00241.$c_Lpresto_Storage$Keys$$anon$1(0, "SignInWithEmail", this);
  $s_Lpresto_Storage$Keys$__SignInWithEmail__Lpresto_Storage$Keys();
}
export { $c_Lpresto_Storage$Keys$ as $c_Lpresto_Storage$Keys$ };
$p = $c_Lpresto_Storage$Keys$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Storage$Keys$;
/** @constructor */
function $h_Lpresto_Storage$Keys$() {
}
export { $h_Lpresto_Storage$Keys$ as $h_Lpresto_Storage$Keys$ };
$h_Lpresto_Storage$Keys$.prototype = $p;
var $d_Lpresto_Storage$Keys$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Storage$Keys$, "presto.Storage$Keys$", ({
  RQ: 1,
  e: 1,
  G: 1
}));
export { $d_Lpresto_Storage$Keys$ as $d_Lpresto_Storage$Keys$ };
var $n_Lpresto_Storage$Keys$;
function $m_Lpresto_Storage$Keys$() {
  if ((!$n_Lpresto_Storage$Keys$)) {
    $n_Lpresto_Storage$Keys$ = new $c_Lpresto_Storage$Keys$();
  }
  return $n_Lpresto_Storage$Keys$;
}
export { $m_Lpresto_Storage$Keys$ as $m_Lpresto_Storage$Keys$ };
var $t_Lpresto_Storage$Keys$__SignInWithEmail = null;
function $u_Lpresto_Storage$Keys$__SignInWithEmail(x) {
  $t_Lpresto_Storage$Keys$__SignInWithEmail = x;
}
export { $t_Lpresto_Storage$Keys$__SignInWithEmail as $t_Lpresto_Storage$Keys$__SignInWithEmail, $u_Lpresto_Storage$Keys$__SignInWithEmail as $u_Lpresto_Storage$Keys$__SignInWithEmail };
//# sourceMappingURL=presto.-Storage$-Keys$.js.map
